(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/charity.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/charity.js');

'use strict';

const charityAtom = svs.lyckoplatsen.shared_charity.jotai.atoms.charityAtom;
const newCustomerCampaignAtom = svs.lyckoplatsen.components.page_play.jotai.atoms.newCustomerCampaignAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const CharityLogo = svs.lyckoplatsen.components.page_play.react.components.CharityLogo;
const Charity = () => {
  const charity = useAtomValue(charityAtom);
  const campaign = useAtomValue(newCustomerCampaignAtom);
  if (campaign.isActive) {
    return React.createElement("div", {
      className: "lp-play-charity"
    }, React.createElement("div", {
      className: "charity-header"
    }, "V\xE4lkomstg\xE5va!"), React.createElement("div", {
      className: "charity-body"
    }, React.createElement("img", {
      className: "campaign-image",
      src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/triss.png"),
      alt: "Triss kampanj"
    })));
  }
  if (!charity) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-play-charity"
  }, React.createElement("div", {
    className: "charity-header"
  }, "Din plats bidrar till"), React.createElement("div", {
    className: "charity-body"
  }, React.createElement(CharityLogo, null)));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Charity
});

 })(window);